import { render, staticRenderFns } from "./toTop.vue?vue&type=template&id=5a3c9a94&scoped=true&"
import script from "./toTop.vue?vue&type=script&lang=js&"
export * from "./toTop.vue?vue&type=script&lang=js&"
import style0 from "./toTop.vue?vue&type=style&index=0&id=5a3c9a94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c9a94",
  null
  
)

export default component.exports